import { gql } from '../../../__generated__/graphql/catalog'

export const MULTIPASS_AUTH_URL = gql(`
  query MultipassAuthURL($redirectUri: String!) {
    customerShopifyUrl(redirectUri: $redirectUri) {
      url
    }
  }
`)
